// import Vue from 'vue';
// import Utility from '@/vue/utility/utility';
import BaseModule from '../_base_module';

// initial state
// shape: [{ id, quantity }]
const state = {
  ...BaseModule.state,

  equipment: {
    none: 'Geen',
    olympic_barbell: 'Olympic Barbell',
    ez_curl: 'EZ Curl',
    dumbbells_30mm: 'Dumbbells - 30mm',
    dumbbell_30mm: 'Dumbbell - 30mm',
    dumbbells_50mm: 'Dumbbells - 50mm',
    dumbbell_50mm: 'Dumbbell - 50mm',
    lat_pulldown: 'Lat Pulldown',
    crossover_cable: 'Crossover Cable (Single)',
    crossover_cables: 'Crossover Cables',
    weight_belt: 'Weight Belt',
  }
};

// getters
const getters = {
  ...BaseModule.getters,
  equipment(state, getters, rootState, rootGetters) {
    return state.equipment;
  }
};

// actions
const actions = {
  ...BaseModule.actions,
  add_to_store({state, commit, dispatch, getters, rootState}, activity) {
    commit('add_to_data', {data: activity, push: true});
  },
  add_to_store_bulk({state, commit, dispatch, getters, rootState}, activities) {
    commit('add_to_data_bulk', {data: activities, push: true});
  },
  store({state, commit, dispatch, getters, rootState}, payload) {
    return dispatch('api/postEndpoint', {
      endpoint: '/users/' + payload.user_id + '/training-sessions/' + payload.training_session_id + '/activities',
      data: payload,
    }, {root: true}).then((response) => {
      let activity = response.data.data;

      commit('add_to_data', {data: activity});

      // En we updaten de activity_order van de training_session
      commit('training_sessions/update_model', {
        id: activity.training_session_id,
        property: 'activity_order',
        value: activity.activity_order,
      }, {root:true})
    });
  },
  update({state, commit, dispatch, getters, rootState}, payload) {
    return dispatch('api/postEndpoint', {
      endpoint: '/users/' + payload.user_id + '/training-sessions/' + payload.training_session_id + '/activities/' + payload.activity_id,
      data: payload,
    }, {root: true}).then((response) => {

      let activity = response.data.data;

      if(typeof payload.add_to_data === 'undefined' || payload.add_to_data) {
        commit('add_to_data',  {data: activity});
      }

      // En we updaten de activity_order van de training_session
      commit('training_sessions/update_model', {
        id: activity.training_session_id,
        property: 'activity_order',
        value: activity.activity_order,
      }, {root:true})
    });
  },
  update_only({state, commit, dispatch, getters, rootState}, payload) {
    // Doet geen add_to_data
    payload.add_to_data = false;
    dispatch('update', payload);
  },
  destroy({state, commit, dispatch, getters, rootState}, payload) {
    return dispatch('api/postEndpoint', {
      endpoint: '/users/' + payload.user_id + '/training-sessions/' + payload.training_session_id + '/activities/destroy',
      data: {
        activity_ids: payload.activity_ids,
      },
    }, {root: true}).then((response) => {

      let training_session = response.data.data;

      // En we updaten de activity_order van de training_session
      commit('training_sessions/update_model', {
        id: training_session.id,
        property: 'activity_order',
        value: training_session.activity_order,
      }, {root:true})

        // Als het gelukt is knallen we ze uit de data
      payload.activity_ids.forEach(activity_id => {
        commit('remove_from_data', {id: payload.activity_id})
      });
    });
  }
};

// mutations
const mutations = {
  ...BaseModule.mutations,
};

export default {

  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
